import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAASUlEQVR42n2NMQrAIBDA/P+3fICoiHUQaQtCoXS63lRIcXIzQ6ZADGs+M6yq5LzhfaK1E2sPQnhmICI4l4hxp9aLUm56f2ewWvyt3XrrA4xzLAAAAABJRU5ErkJggg=="};
